import { useState, useCallback } from 'react';

/**
 * Encapsulates the create-project modal state that App lifts so it survives
 * view transitions (Add Sites, Site picker, and the post-boundary
 * Sites-in-Boundary flow with its pending shapefile payload).
 *
 * Previously these were five separate useState declarations in App with the
 * reset logic duplicated across finishCreateProject and the Cancel handler.
 * Centralizing them here keeps the open/close/reset transitions in one place.
 */
export function useCreateProjectModals() {
  const [addSitesModalOpen, setAddSitesModalOpen] = useState(false);
  const [siteModalOpen, setSiteModalOpen] = useState(false);
  const [sitesInBoundaryModalOpen, setSitesInBoundaryModalOpen] = useState(false);
  const [boundaryGeometryForModal, setBoundaryGeometryForModal] = useState(null);
  const [pendingShapefileData, setPendingShapefileData] = useState(null);

  // Close every create-project modal and clear its transient payloads.
  const reset = useCallback(() => {
    setAddSitesModalOpen(false);
    setSiteModalOpen(false);
    setSitesInBoundaryModalOpen(false);
    setBoundaryGeometryForModal(null);
    setPendingShapefileData(null);
  }, []);

  // Open the Sites-in-Boundary modal after a project is created by drawing a
  // boundary, stashing any shapefile data to apply once sites are linked.
  const openSitesInBoundary = useCallback((geometry, shapefileData) => {
    setBoundaryGeometryForModal(geometry);
    if (shapefileData) setPendingShapefileData(shapefileData);
    setSitesInBoundaryModalOpen(true);
  }, []);

  return {
    addSitesModalOpen,
    setAddSitesModalOpen,
    siteModalOpen,
    setSiteModalOpen,
    sitesInBoundaryModalOpen,
    boundaryGeometryForModal,
    pendingShapefileData,
    reset,
    openSitesInBoundary,
  };
}
